import React from 'react';
import { Form } from 'react-bootstrap';
import { Course } from '../types';

interface CourseCheckListProps {
  courses: Course[];
  isChecked: (course: Course) => boolean;
  onToggle: (course: Course) => void;
  emptyMessage: string;
}

const CourseCheckList = ({
  courses, isChecked, onToggle, emptyMessage,
}: CourseCheckListProps) => {
  if (courses.length === 0) {
    return (<p className="assignments-font-size">{emptyMessage}</p>);
  }
  return (
    <>
      {courses.map((course) => (
        <Form.Group key={course.id} className="d-flex justify-content-between">
          <Form.Check
            onChange={() => { onToggle(course); }}
            checked={isChecked(course)}
            type="checkbox"
            className="text-capitalize"
            label={course.name}
          />
        </Form.Group>
      ))}
    </>
  );
};

export default CourseCheckList;
